// extracted by mini-css-extract-plugin
export default {"container":"podfooter_container__hEbOy","allBlock":"podfooter_allBlock__FTmss","texts":"podfooter_texts__KlOwj","buttons":"podfooter_buttons__4LlYh"};